<span>{{ $safeNavigationMigration(params()?.value) | infoDisplay }}</span>
